<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Scan Booked List</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-2">
                        <input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" />
                    </div>

                    <div class="col-sm-2">
                        <mat-select placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue('circle')"
                            multiple>
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option>All</mat-option>
                            <mat-option [value]="cir.id" *ngFor="let cir of circles">{{cir.name}}
                            </mat-option>
                        </mat-select>
                    </div>

                    <!-- <div class="col-sm-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Appointment Date Filter</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div> -->

                    <div class="col-sm-4">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadScanBookList(0,perpage)">
                            <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>

                </div>

            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadScanBookList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Glamyo Partner Id</th>
                            <th class="tablefixcoloumn">Patient Name</th>
                            <th>Patient Age</th>
                            <th>Gender</th>
                            <th>Circle</th>
                            <th>Treatment</th>
                            <th>Scan files link</th>
                            <th>Link Shared at</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let scan_book of scanBookList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{scan_book.glamyo_patient_id}}</td>
                            <td class="tablefixcoloumn">{{scan_book.lead_name}}</td>
                            <td>{{scan_book.patient_age}}</td>
                            <td>{{scan_book.gender}}</td>
                            <td>{{scan_book.circle_name}}</td>
                            <td>{{scan_book.treatment_name}}</td>
                            <td>{{scan_book.google_form_link}}</td>
                            <td><span *ngIf="scan_book.link_send_on">{{scan_book.link_send_on*1000 | date:'dd MMM, yyyy hh:mm aa'}}</span></td>
                            <td>
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Action
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" routerLink="/update-ods-scan-logs/{{scan_book.id}}"><i
                                                class="fa fa-pen"></i> Upload Plan</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="9" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !scanBookList.length">
                            <td colspan="9"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>